import { getPreloadsFromInitialPath } from '@trello/quickload';

// for now, we want to get the initial preloads upon rendering and not on transition
export const getValidPreloadsForRoute = () =>
  getPreloadsFromInitialPath().preloads.map(({ queryName }) => queryName);
